import * as styles from "../styles"
import { allAgendas } from "../data/agendas"
import { useDateTime } from "../utils"
import {Column, Row} from "./layout"
import { useContext } from "preact/hooks"
import { DayContext } from "../contexts/DayContext"
import { eventDays, getDay } from "../assets"

const baseStyle = {
	...styles.fcenter,
	justifyContent: "flex-start",
	width: "100%",
	textDecoration: "none",
	fontSize: "0.55vw",
	marginBottom: "10px",
	lineHeight: 1.2,
}
const rowStyles = [
	{
		...baseStyle,
		color: "#888",
	},{
		...baseStyle,
		fontWeight: "bold",
		color: "#3c1d4a",
	},{
		...baseStyle,
		color: "#3c1d4a",
	}
]

export const isPastPresentFuture = (startField, endField, now) => (event, i, arr) => {
	const start = new Date(event[startField])
	const end = new Date(event[endField])

	const farEnd = new Date(end.valueOf() + 7200000)
	if (now > farEnd) return {
		...event,
		style: {display: "none"},
	}
	if (now > end) return {
		...event,
		style: rowStyles[0]
	}
	else if (now > start && now < end) return {...event, active: true, style: rowStyles[1]}
	else if (now < start) return {...event, start, end, style: rowStyles[2]}
}

export const AgendaSidebar = ({room, agendas = null, startField = "start", endField = "end"}) => {
	
	const context = useContext(DayContext)
	const now = useDateTime()
	// const day = eventDays[getDay(context.date.day)]
	const day = context.date.day !== null ? eventDays[getDay(context.date.day)] : new Date()

	const events = (agendas || allAgendas).filter(event => event.room === room && day.toISOString().slice(0, 10) === new Date(event[startField]).toISOString().slice(0, 10))

	return <Column class="breakout-agenda" styleOverride={{
		overflowX: "hidden",
		overflowY: "scroll",
		scrollbarWidth: "none",
		maxHeight: "100%",
	}}>
		{events.map(isPastPresentFuture(startField, endField, new Date())).map(event => {
			const start = new Date(event[startField])
			const end = new Date(event[endField])
			const generateTime = (date) => {
				return `${date.getHours() >= 10 ? date.getHours() : `0${date.getHours()}`}:${date.getMinutes() > 10 ? date.getMinutes() : `0${date.getMinutes()}`}`
			}

			return <Row styleOverride={{...event.style, flexDirection: "column", alignItems: "flex-start"}}>
				<span class="agenda-time">
					<div>{generateTime(start)} - {generateTime(end)}</div> <hr style={{width: "100%"}} />
				</span>
				<span class="agenda-item" style={{marginLeft: "10px"}}>
					{event.title}
				</span>
			</Row>
		})}
	</Column>
}